import { actions } from './actions';
import { mutations } from './mutations';
import { getters } from './getters';

const state = {
  uiFlags: {
    isFetchingSummary: false,
    isFetchingMentions: false,
    isFetchingProfiles: false,
    isFetchingInsights: false,
    isFetchingReactionAnalysis: false,
    isCreating: false,
    isGeneratingReport: false,
    isFetchingClusters: false,
    isFetchingNarratives: false,
    isFetchingSuggestions: false,
    isFetchingResponseLibrary: false,
    isFetchingCopilot: false,
    isRunningCopilot: false,
  },
  summary: null,
  sentiment: [],
  engagement: { topPosts: [], averages: { likes: 0, comments: 0, shares: 0 } },
  competitors: [],
  topMentioners: [],
  mentions: { items: [], page: 1, totalPages: 1, total: 0 },
  profiles: [],
  settings: {
    collectIntervalHours: 168,
    presets: [6, 12, 24, 72, 168, 336, 720],
  },
  politicalInsights: null,
  publicReaction: null,
  publicReactionAnalysis: null,
  topics: [],
  reports: [],
  currentReport: null,
  clusters: { clusters: [], generatedAt: null },
  alerts: [],
  alertsUnreadCount: 0,
  contentBreakdown: [],
  conversionIndices: null,
  narratives: { narratives: [], generatedAt: null },
  emotionBreakdown: [],
  contentSuggestions: { suggestions: [], generatedAt: null },
  responseLibrary: { templates: [], generatedAt: null },
  copilot: {
    actions: [],
    contextSummary: null,
    confidence: 0,
    generatedAt: null,
  },
  territorialBreakdown: [],
  demographicBreakdown: { age: [], gender: [], affinity: [] },
  territorialSegmentation: { losing: [], mobilizable: [], grow: [] },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
